export enum ApiOperationType {
    submitBidsOnBehalf = 1,
    BlastMessage = 2,
    SendAutoFeedbacks = 3,
    SubmitAxedFinal = 4,
    SubmitBid = 5,
    SubmitBidRequest = 6
}
